import Vue from "vue";
import App from "./App";
import router from "./router";
import VueLazyLoad from "vue-lazyload";

import api from "./api/index";
import store from "./vuex/store";
import SIdentify from "./components/identify.vue";
import "vant/lib/index.css";
import "./assets/js/rem";
import "./assets/js/vant";
import './assets/js/components'


const CommonJs = require("./assets/js/common"); // 全局方法

// import VConsole from 'vconsole'
// new VConsole();

Vue.use(SIdentify);
Vue.prototype.$api = api;
Vue.prototype.$common = CommonJs.default;

router.afterEach((to, from, next) => {
  if (to.meta.keepAlive != true && to.name != "Goods") {
    window.scrollTo(0, 0);
  }
}); //回到顶部

Vue.prototype.$api = api;
Vue.config.productionTip = false;
Vue.use(VueLazyLoad, {
  error: "/static/errorimg1.png",
  loading: "/static/loadingimg.png",
  filter: {
    // index(listener, opts) {
    //   listener.src=listener.src.replace('/n0/','/n1/')
    // }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js